<template>
    <div class="rank-container app-container">
      <h2 class="page-title"><i class="el-icon-trophy"></i> 日排行榜</h2>
      <el-table
        :data="list"
        v-loading="loading"
        style="width: 100%"
        :default-sort="{ prop: 'TotalScore', order: 'descending' }"
      >
        <el-table-column label="排名" width="100">
          <template slot-scope="scope">
            <span v-if="scope.$index < 3" class="medal">
              <i :class="['el-icon-medal', `medal-${scope.$index + 1}`]"></i>
            </span>
            <span v-else>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="UserName" label="玩家名称"></el-table-column>
        <el-table-column prop="TotalScore" label="积分" width="120">
          <template slot-scope="{ row }">
            {{ row.TotalScore.toLocaleString() }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </template>
  
  <script>
  import { getLeaderboard } from '@/api/api'
  
  export default {
    data() {
      return {
        list: [],
        loading: false
      }
    },
    methods: {
      fetchData() {
        this.loading = true
        getLeaderboard('daily').then(res => {
          if (res.data.success) {
            this.list = res.data.response
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    mounted() {
      this.fetchData()
    }
  }
  </script>
  
  <style scoped>
  .page-title {
    color: #666;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }
  
  .medal {
    font-size: 24px;
    display: inline-block;
    line-height: 1;
  }
  
  .medal-1 { color: #ffd700; }
  .medal-2 { color: #c0c0c0; }
  .medal-3 { color: #cd7f32; }
  
  ::v-deep .el-table__row:first-child {
    background-color: #fffae6;
  }
  ::v-deep .el-table__row:nth-child(2) {
    background-color: #f8f8f8;
  }
  ::v-deep .el-table__row:nth-child(3) {
    background-color: #fdf5e6;
  }
  </style>